import React, { useContext } from 'react'
import { ButtonPrimary } from 'front-end/src/components'
import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import omitDeep from 'omit-deep-lodash'
import { Trans } from '@lingui/macro'
import Tooltip from 'front-end/src/components/common/tooltip/Tooltip'
import { CampaignFilterInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import {
  useSetCampaignFiltersMutation,
  useSetDashboardFiltersMutation
} from './SaveFiltersButton.codegen'
import { ManageCampaignContext } from '../ManageCampaignPage'
import {
  DASHBOARD_TABS,
  ManageDashboardPageContext
} from 'front-end/src/pages/dashboards-page/manage/ManageDashboardPage'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const prepareCampaignFilterForUpsert = (filter, userId) => {
  if (!filter.created_at) {
    filter.created_at = new Date()
  }
  if (!filter.created_by) {
    filter.created_by = userId
  }
  return omitDeep(filter, '__typename') as CampaignFilterInput
}

export const SaveCampaignFiltersButton = ({
  filters,
  campaignId
}: {
  filters: CampaignFilterInput[]
  campaignId: number
}) => {
  const { refetchCampaign } = useContext(ManageCampaignContext)
  const [save, { loading }] = useSetCampaignFiltersMutation()
  const { session } = usePublicApiSession()

  return (
    <ButtonPrimary
      onClick={async () => {
        try {
          await save({
            variables: {
              campaignId,
              filters: filters.map((filter) =>
                prepareCampaignFilterForUpsert(filter, session?.user.id)
              )
            }
          })

          refetchCampaign()
        } catch (err) {
          throw err
        } finally {
          navigateTo(linkBuilder.campaign(campaignId))
        }
      }}
      disabled={filters.length === 0}
      isLoading={loading}
    >
      <Trans>Save target audience</Trans>
    </ButtonPrimary>
  )
}

export const SaveDashboardFiltersButton = ({
  filters,
  dashboardId
}: {
  filters: CampaignFilterInput[]
  dashboardId: number
  setIsLoading: (loading: boolean) => void
}) => {
  const { refetch, setIsLoading } = useContext(ManageDashboardPageContext)
  const [save, { loading }] = useSetDashboardFiltersMutation()
  const { session } = usePublicApiSession()

  return (
    <Tooltip
      text={
        filters.length === 0 ? (
          <Trans>Can't save empty audience filter</Trans>
        ) : (
          ''
        )
      }
    >
      <ButtonPrimary
        onClick={async () => {
          try {
            await save({
              variables: {
                dashboardId,
                filters: filters.map((filter) =>
                  prepareCampaignFilterForUpsert(filter, session?.user.id)
                )
              }
            })
            await refetch()
            setIsLoading(true)
          } catch (err) {
            throw err
          } finally {
            navigateTo(
              linkBuilder.dashboardManage(dashboardId, DASHBOARD_TABS[2])
            )
            setIsLoading(false)
          }
        }}
        disabled={filters.length === 0}
        isLoading={loading}
      >
        <Trans>Save target audience</Trans>
      </ButtonPrimary>
    </Tooltip>
  )
}
